export const GET_LOCKS_REQUEST = 'GET_LOCKS_REQUEST';
export const GET_LOCKS_DATA = 'GET_LOCKS_DATA';
export const GET_LOCKS_ERROR = 'GET_LOCKS_ERROR';

export const UPDATE_QUICK_FILTER = 'UPDATE_QUICK_FILTER';
export const FILTER_LOCKS = 'FILTER_LOCKS';
export const SET_LOCKS_SORT_DATA = 'SET_LOCKS_SORT_DATA';
export const SORT_LOCKS = 'SORT_LOCKS';